/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {FormStateInterface} from '@/store/modules/form/types';
import {actions} from '@/store/modules/form/actions';
import {getters} from '@/store/modules/form/getters';
import {mutations} from '@/store/modules/form/mutations';


export const state: FormStateInterface = {
    stage: 1,
    reportStage: {},
    detailsStage: {
        problem: {},
        hardware: {},
        subscription: false,
    },
};

const namespaced: boolean = true;

export const formStateModule: Module<FormStateInterface, RootState> = {
    namespaced,
    state,
    actions,
    getters,
    mutations,
};
